// extracted by mini-css-extract-plugin
export var bacgroundImage = "LatestBlogs-module--bacgroundImage--2a5a4";
export var blogCard = "LatestBlogs-module--blogCard--23e39";
export var containerStyling = "LatestBlogs-module--containerStyling--2e43e";
export var contentCardsContainer = "LatestBlogs-module--contentCardsContainer--98515";
export var contentExtraStyling = "LatestBlogs-module--contentExtraStyling--22d31";
export var ctaExtraStyling = "LatestBlogs-module--ctaExtraStyling--4bd85";
export var extraBtnClassName = "LatestBlogs-module--extraBtnClassName--cf3a4";
export var headerStyling = "LatestBlogs-module--headerStyling--acd4f";